import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { permissionGuard } from './core/guards/permission.guard';
import { LoginComponent } from './pages/login/login';
import { ShellComponent } from './layout/shell/shell';
import { DashboardComponent } from './pages/dashboard/dashboard';
import { PropertyListComponent } from './pages/properties/property-list/property-list';
import { PropertyDetailComponent } from './pages/properties/property-detail/property-detail';
import { DocumentListComponent } from './pages/documents/list/document-list';
import { PlanListComponent } from './pages/plans/plan-list/plan-list';
import { PlanFormComponent } from './pages/plans/plan-form/plan-form';
import { UserListComponent } from './pages/users/user-list/user-list';
import { AdListComponent } from './pages/ads/ad-list/ad-list';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard',      component: DashboardComponent },
      { path: 'properties',     component: PropertyListComponent, canActivate: [permissionGuard('PROPERTIES_READ')] },
      { path: 'properties/:id', component: PropertyDetailComponent, canActivate: [permissionGuard('PROPERTIES_READ')] },
      { path: 'back-office/documents', component: DocumentListComponent, canActivate: [permissionGuard('DOCUMENTS_READ')] },
      { path: 'plans',          component: PlanListComponent, canActivate: [permissionGuard('PLANS_READ')] },
      { path: 'plans/new',      component: PlanFormComponent, canActivate: [permissionGuard('PLANS_CREATE')] },
      { path: 'plans/:id/edit', component: PlanFormComponent, canActivate: [permissionGuard('PLANS_UPDATE')] },
      { path: 'users',          component: UserListComponent, canActivate: [permissionGuard('USERS_READ')] },
      { path: 'publicite',            component: AdListComponent, canActivate: [permissionGuard('ADS_READ')] },
      { path: '',               redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];
